import { header, handleResponse } from '../helpers';

export const service = {
    get, put, post, _import, destroy, download, loadHtml
};

function post(url, request_data, nonce) {
    const form = new FormData();
    Object.keys(request_data).forEach(function (item) {
        if (request_data[item] !== undefined) {
            if (Array.isArray(request_data[item])) {
                request_data[item].forEach(function (value, index) {
                    form.append(item + '[' + index + ']', JSON.stringify(value));
                });
            } else {
                form.append(item, request_data[item]);
            }
        }
    });
    const requestOptions = {
        method: "POST",
        headers: header('POST', nonce),
        body: form
    };
    return fetch(
        url,
        requestOptions
    ).then(handleResponse);
}

function put(url, request_data, nonce) {
    const requestOptions = {
        method: "PUT",
        headers: header('PUT', nonce),
        body: JSON.stringify(request_data)
    };
    return fetch(
        url,
        requestOptions
    ).then(handleResponse);
}

function get(url, nonce) {
    const requestOptions = {
        method: "GET",
        headers: header('GET', nonce),
    };
    return fetch(
        url,
        requestOptions
    ).then(handleResponse);
}

function loadHtml(url, nonce) {
    const requestOptions = {
        method: "GET",
    };
    return fetch(
        url,
        requestOptions
    ).then(handleResponse);
}

function destroy(url, request_data = null) {
    const requestOptions = {
        method: "DELETE",
        headers: header('DELETE'),
        body: JSON.stringify(request_data ? request_data : [])
    };
    return fetch(
        url,
        requestOptions
    ).then(handleResponse);
}

function _import(url, request_data) {
    const form = new FormData();
    Object.keys(request_data).forEach(function (item) {
        if (item === "column") {
            form.append(item, JSON.stringify(request_data[item]));
        } else {
            form.append(item, request_data[item]);
        }
    });
    const requestOptions = {
        method: "POST",
        headers: header(),
        body: form
    };
    return fetch(
        url,
        requestOptions
    ).then(handleResponse);
}

function download(url) {
    const requestOptions = {
        method: "GET",
        headers: header('GET'),
    };
    return fetch(
        url,
        requestOptions
    );
}